import { AnimatePresence, motion } from 'motion/react'
import { transitions } from '@/lib/motion/presets'
import type { PanelSwitchProps } from './PanelSwitch.types'

const TRAVEL = 24

// Slides panels along tab order; mode="wait" stops unequal heights overlapping.
export function PanelSwitch({
  panelKey,
  index,
  previousIndex,
  children,
}: PanelSwitchProps) {
  const forward = index >= previousIndex

  return (
    <AnimatePresence initial={false} mode="wait">
      <motion.div
        key={panelKey}
        initial={{ opacity: 0, x: forward ? TRAVEL : -TRAVEL }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: forward ? -TRAVEL : TRAVEL }}
        transition={transitions.panel}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
